export const basicStats = [
  "PTS",
  "AST",
  "FGA",
  "FGM",
  "FG_PCT",
  "FG3A",
  "FG3M",
  "FG3_PCT",
  "BLK",
  "STL",
  "REB",
  "DREB",
  "OREB",
  "FTA",
  "FTM",
  "FT_PCT",
  "GS",
  "GP",
  "TOV",
  "PF"
];

export const NBA_API_HEADERS = {
  PTS: "Points",
  AST: "Assists",
  BLK: "Blocks",
  STL: "Steals",
  REB: "Rebounds",
  DREB: "Defensive Rebounds",
  OREB: "Offensive Rebounds",
  FGA: "Field Goal Attempts",
  FGM: "Field Goals Made",
  FG_PCT: "Field Goal Percentage",
  FG3A: "3PT Field Goal Attempts",
  FG3M: "3PT Field Goals Made",
  FG3_PCT: "3PT Field Goal Percentage",
  FTA: "Free Throw Attempts",
  FTM: "Free Throws Made",
  FT_PCT: "Free Throw Percentage",
  GS: "Games Started",
  GP: "Games Played",
  TOV: "Turnovers",
  PF: "Personal Fouls"
};
